/* src/app/chase-gateway/chase-gateway.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.row {
  margin: 0px !important;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.userbtn_main {
  margin-top: -60px;
  position: absolute;
  right: 0px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu > li > a:hover {
  background-color: #008ad0;
  color: #ffffff;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.header_txt {
  font-size: 24px;
  padding: 20px 0px 0px 0px;
}
.payment_txt {
  color: #858585;
  font-size: 17px;
  font-weight: bold;
  padding: 5px;
}
.belowpayment_main {
  padding: -1px 0px;
}
.existing_act {
  padding: 0px 10px 0px 0px;
}
.make_payment {
  background-color: #4eb700 !important;
  border-radius: 20px !important;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize !important;
}
.note_main {
  background-color: #e3e3e3;
  padding: 10px;
  border-radius: 5px;
  line-height: 28px;
  margin-left: 604px;
  margin-top: -61px;
}
.create_actmain {
  padding: 6px;
}
.cc_main {
  padding: 0px;
  margin-top: 10px;
}
.goback {
  background-color: #028ba3 !important;
  float: left;
  color: #fff;
  padding: 0px 20px !important;
  border-radius: 30px !important;
  cursor: pointer;
  height: 36px;
  line-height: 0px !important;
  text-transform: unset;
  outline: none;
  margin-top: -10px;
  text-transform: capitalize !important;
}
.btn:hover {
  color: #ffffff;
}
.line {
  border-top: 3px solid #e3e3e3;
  border-radius: 5px;
  margin-top: 25px;
  clear: both;
  margin-bottom: 12px;
}
.checkbox_modified {
  opacity: 1 !important;
  margin: 0px !important;
  left: 0px !important;
  font-size: 20px !important;
  top: 2px;
}
.chk_txt {
  margin-left: 10px;
}
@media (min-width: 300px) and (max-width: 700px) {
  .user_main {
    padding: 15px 28px 7px 0px;
  }
  .logo {
    padding: 25px 14px 0px 25px;
  }
  .row {
    margin-right: -15px;
    margin-left: -15px;
  }
  .goback {
    margin-top: 10px;
  }
  .make_payment {
    margin-top: 10px;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .cc_main {
    float: none;
  }
  .goback {
    margin-top: 10px;
  }
  .make_payment {
    margin-top: 10px;
  }
}
@media only screen and (min-width: 993px) {
  .container {
    width: 100% !important;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px !important;
  }
}
.TransactionAlertMesg {
  font-weight: bold;
  position: right;
  margin: 12%;
  position: absolute;
  padding: 10px;
  font-size: larger;
  color: red;
  margin-left: -515px;
}
/*# sourceMappingURL=chase-gateway.component.css.map */
